import { render, staticRenderFns } from "./ResellerInvoiceViewLogs.vue?vue&type=template&id=3b91c50f&"
import script from "./ResellerInvoiceViewLogs.vue?vue&type=script&lang=js&"
export * from "./ResellerInvoiceViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports